module.exports = __webpack_public_path__ + "img/logo.38babbc9.svg";